// extracted by mini-css-extract-plugin
export default {"space128":"FullProduct_space128__7Za96"};